export const Problem = () => {
  return (
    <section data-testid="problem-section" className="bg-[#F0EFEB] py-24 sm:py-32 border-y border-[#1C1C1A]/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-12 gap-y-14 gap-x-8">
          <div className="col-span-12 md:col-span-5">
            <p className="label-eyebrow text-[#143628] mb-6">The Problem</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-[1.05] tracking-tight text-[#1C1C1A]">
              Good candidates get lost in the noise.
              <span className="block italic text-[#143628] mt-2">Good roles never reach them.</span>
            </h2>
          </div>

          <div className="col-span-12 md:col-span-6 md:col-start-7 space-y-7 text-[#4A4A48] text-lg leading-relaxed">
            <p>
              Engineers send hundreds of applications into the void. Recruiters drown in
              irrelevant resumes. The signal is buried under the noise - and the best matches
              never find each other.
            </p>
            <p className="text-[#1C1C1A] font-medium">
              JobNex fixes both ends. We curate top-quality candidates and connect them
              directly to HRs who actually respond.
            </p>

            <div className="grid grid-cols-2 gap-4 pt-6">
              <div className="border-l border-[#143628] pl-4">
                <p className="font-serif-display text-4xl text-[#143628]">96%</p>
                <p className="text-xs uppercase tracking-widest text-[#4A4A48] mt-1">
                  Avg. HR response within 7 days
                </p>
              </div>
              <div className="border-l border-[#D4B886] pl-4">
                <p className="font-serif-display text-4xl text-[#143628]">6 weeks</p>
                <p className="text-xs uppercase tracking-widest text-[#4A4A48] mt-1">
                  Median time to first offer
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;
